import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/website/assets/img/business/sack-dollar.png")